import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getCommentWithUserData } from '../../../api/comments';

import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentWithUserData } from '../../../utils/comments';
import { REQUEST } from '../../../constants/request';

export const fetchComment = createAsyncThunk(
  'comments/fetchComment',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, commentUserDaraResponse] =
        await getCommentWithUserData(commentData, {
          cancelToken: source.token,
        });
      return mergeCommentWithUserData(commentResponse, commentUserDaraResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return (
        state.comments.comments.comment.request[generateCommentCIDKey(path)]
          ?.loading !== REQUEST.pending
      );
    },
  },
);

export const fetchCommentExtraReducers = builder => {
  builder
    .addCase(fetchComment.pending, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.comments.comment.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(fetchComment.fulfilled, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.comments.comment.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey] = action.payload;
          if (!state.comments.comment.allIds.includes(commentCIDKey)) {
            state.comments.comment.allIds.push(commentCIDKey);
          }
        },
      );
    })
    .addCase(fetchComment.rejected, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.comments.comment.request[commentCIDKey],
        action,
      );
    });
};
